<!--
  ~ Copyright (c) 1999 - 2019 Accorto, Inc. - All rights reserved.
  -->

<div class="slds-button-group" role="group">
  <button (click)="onWeekPrevious()"
          class="slds-button slds-button_icon slds-button_icon-border"
          id="ws-previous"
          title="Previous Week">
    <svg aria-hidden="true"
         class="slds-button__icon">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#chevronleft"
           xmlns:xlink="http://www.w3.org/1999/xlink"></use>
    </svg>
    <span class="slds-assistive-text" i18n>Previous Week</span>
  </button>

  <div class="slds-form-element">
    <div class="slds-form-element__control">
      <input (click)="onClick()"
             [formControl]="weekStart"
             [formGroup]="formGroup"
             class="slds-input"
             id="ws-input"
             name="weekStart"
             [title]="dateTitle"
             type="text">
      <div class="slds-form-element__help">{{ errorMessage }}</div>
      <acc-date-picker (dateSelected)="onDateSelected($event)"
                       *ngIf="showDateDialog"
                       [initialDate]="theDate"
                       [mode]="'w'">
      </acc-date-picker>
    </div>
  </div>

  <button (click)="onWeekNext()"
          class="slds-button slds-button_icon slds-button_icon-border"
          id="ws-next"
          title="Next Week">
    <svg aria-hidden="true" class="slds-button__icon">
      <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#chevronright"
           xmlns:xlink="http://www.w3.org/1999/xlink"></use>
    </svg>
    <span class="slds-assistive-text i18n">Next Week</span>
  </button>
</div>
